import { createGlobalStyle, css } from 'styled-components';
import { normalize } from 'styled-normalize';

const GlobalStyles = createGlobalStyle`
  ${normalize}
  
  html {
    box-sizing: border-box;
  }
  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }
  body {
    font-family: UniversNextforHSBC, 'Helvetica Neue', Helvetica, Arial, sans-serif;
    color: ${({ theme }) => theme.colors.charcoal};
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
    line-height: 1.5;
    margin: 0;
    overflow-x: hidden;
  }
  input,
  select,
  option {
    font-family: UniversNextforHSBC, 'Helvetica Neue', Helvetica, Arial, sans-serif;
  }
  dd {
    margin: 0;
  }
  ol {
    margin: 0;
    padding: 0;
  }
  button,
  input,
  optgroup,
  select,
  textarea {
    font-family: inherit;
    font-size: 100%;
  }
 
  :root {
    --font-weight-light: 300;
    --font-weight-regular: 400;
    --font-weight-medium: 600;

    ${({ theme: { breakpoints, fUnit } }) => {
      return css`
        --f0: ${fUnit(0)};
        --f1: ${fUnit(1)};
        --f2: ${fUnit(2)};
        --f3: ${fUnit(3)};
        --f4: ${fUnit(4)};
        --f5: ${fUnit(5)};
        --f6: ${fUnit(6)};
        --f7: ${fUnit(7)};
        --f8: ${fUnit(8)};
        --f9: ${fUnit(9)};
        --f10: ${fUnit(10)};
        --f11: ${fUnit(11)};
        --f12: ${fUnit(12)};
        --f13: ${fUnit(13)};
        --f14: ${fUnit(14)};
        --f15: ${fUnit(15)};
        --f16: ${fUnit(16)};
        --f17: ${fUnit(17)};
        --f18: ${fUnit(18)};
        --f19: ${fUnit(19)};
        --f20: ${fUnit(20)};
        --f21: ${fUnit(21)};
        --f22: ${fUnit(22)};
        --f23: ${fUnit(23)};
        --f24: ${fUnit(24)};
        --f25: ${fUnit(25)};
        --f26: ${fUnit(26)};
        --f27: ${fUnit(27)};
        --f28: ${fUnit(28)};
        --f29: ${fUnit(29)};
        --f30: ${fUnit(30)};
        --f31: ${fUnit(31)};
        --f32: ${fUnit(32)};
        --f33: ${fUnit(33)};
        --f34: ${fUnit(34)};
        --f35: ${fUnit(35)};
        --f36: ${fUnit(36)};
        --f37: ${fUnit(37)};
        --f38: ${fUnit(38)};
        --f39: ${fUnit(39)};
        --f40: ${fUnit(40)};
        --f41: ${fUnit(41)};
        --f42: ${fUnit(42)};
        --f43: ${fUnit(43)};
        --f44: ${fUnit(44)};

        --r0: ${fUnit(0)};
        --r1: ${fUnit(4)};
        --r2: ${fUnit(8)};
        --r3: ${fUnit(12)};
        --r4: ${fUnit(16)};
        --r5: ${fUnit(20)};
        --r6: ${fUnit(24)};
        --r7: ${fUnit(28)};
        --r8: ${fUnit(32)};
        --r9: ${fUnit(36)};
        --r10: ${fUnit(40)};
        --r11: ${fUnit(44)};
        --r12: ${fUnit(48)};

        --font-size-1: ${fUnit(33)};
        --font-size-2: ${fUnit(28)};
        --font-size-3: ${fUnit(23)};
        --font-size-4: ${fUnit(19)};
        --font-size-5: ${fUnit(16)};
        --font-size-6: ${fUnit(14)};
        --font-size-7: ${fUnit(12)};

        --line-height-1: ${fUnit(40)};
        --line-height-2: ${fUnit(36)};
        --line-height-3: ${fUnit(30)};
        --line-height-4: ${fUnit(27)};
        --line-height-5: ${fUnit(24)};
        --line-height-6: ${fUnit(20)};
        --line-height-7: ${fUnit(16)};

        ${breakpoints.up(breakpoints.md)} {
          --r0: ${fUnit(4)};
          --r1: ${fUnit(8)};
          --r2: ${fUnit(12)};
          --r3: ${fUnit(16)};
          --r4: ${fUnit(20)};
          --r5: ${fUnit(24)};
          --r6: ${fUnit(28)};
          --r7: ${fUnit(32)};
          --r8: ${fUnit(36)};
          --r9: ${fUnit(40)};
          --r10: ${fUnit(48)};
          --r11: ${fUnit(52)};
          --r12: ${fUnit(56)};

          --font-size-1: ${fUnit(44)};
          --font-size-2: ${fUnit(35)};
          --font-size-3: ${fUnit(28)};
          --font-size-4: ${fUnit(22)};
          --font-size-5: ${fUnit(16)};
          --font-size-6: ${fUnit(14)};
          --font-size-7: ${fUnit(12)};

          --line-height-1: ${fUnit(50)};
          --line-height-2: ${fUnit(42)};
          --line-height-3: ${fUnit(36)};
          --line-height-4: ${fUnit(31)};
          --line-height-5: ${fUnit(24)};
          --line-height-6: ${fUnit(20)};
          --line-height-7: ${fUnit(16)};
        }

        ${breakpoints.up(breakpoints.xl)} {
          --r0: ${fUnit(8)};
          --r1: ${fUnit(12)};
          --r2: ${fUnit(16)};
          --r3: ${fUnit(20)};
          --r4: ${fUnit(24)};
          --r5: ${fUnit(28)};
          --r6: ${fUnit(32)};
          --r7: ${fUnit(36)};
          --r8: ${fUnit(40)};
          --r9: ${fUnit(48)};
          --r10: ${fUnit(56)};
          --r11: ${fUnit(60)};
          --r12: ${fUnit(64)};

          --font-size-1: ${fUnit(57)};
          --font-size-2: ${fUnit(43)};
          --font-size-3: ${fUnit(32)};
          --font-size-4: ${fUnit(24)};
          --font-size-5: ${fUnit(16)};
          --font-size-6: ${fUnit(14)};
          --font-size-7: ${fUnit(12)};
        }
      `;
    }}

    --gt-green-leaf: ${({ theme: { colors } }) => colors.greenLeaf};
    --gt-HSBC-red: ${({ theme: { colors } }) => colors.HSBC_red};
    --gt-black: ${({ theme: { colors } }) => colors.black};
    --gt-white: ${({ theme: { colors } }) => colors.white};
    --gt-light-pearl: ${({ theme: { colors } }) => colors.lightPearl};
    --gt-pearl: ${({ theme: { colors } }) => colors.pearl};
    --gt-silver: ${({ theme: { colors } }) => colors.silver};
    --gt-pewter: ${({ theme: { colors } }) => colors.pewter};
    --gt-charcoal: ${({ theme: { colors } }) => colors.charcoal};
    --gt-red-error: ${({ theme: { colors } }) => colors.redError};
    --gt-amber-warning: ${({ theme: { colors } }) => colors.amberWarning};
    --gt-green: ${({ theme: { colors } }) => colors.green};
    --gt-blue: ${({ theme: { colors } }) => colors.blue};
    --gt-red-tint: ${({ theme: { colors } }) => colors.redTint};
    --gt-amber-tint: ${({ theme: { colors } }) => colors.amberTint};
    --gt-green-tint: ${({ theme: { colors } }) => colors.greenTint};
    --gt-blue-tint: ${({ theme: { colors } }) => colors.blueTint};
    --gt-dusk-pearl: ${({ theme: { colors } }) => colors.duskPearl};
    --gt-jade: ${({ theme: { colors } }) => colors.jade};
    --gt-emerald: ${({ theme: { colors } }) => colors.emerald};
    --gt-amber: ${({ theme: { colors } }) => colors.amber};
    --gt-ruby: ${({ theme: { colors } }) => colors.ruby};
    --gt-lolite: ${({ theme: { colors } }) => colors.lolite};
    --gt-sapphire: ${({ theme: { colors } }) => colors.sapphire};
    --gt-dark-pearl: ${({ theme: { colors } }) => colors.darkPearl};
    --gt-dark-jade: ${({ theme: { colors } }) => colors.darkJade};
    --gt-dark-emerald: ${({ theme: { colors } }) => colors.darkEmerald};
    --gt-dark-amber: ${({ theme: { colors } }) => colors.darkAmber};
    --gt-dark-ruby: ${({ theme: { colors } }) => colors.darkRuby};
    --gt-dark-lolite: ${({ theme: { colors } }) => colors.darkLolite};
    --gt-dark-sapphire: ${({ theme: { colors } }) => colors.darkSapphire};

    --gt-tundora: ${({ theme: { colors } }) => colors.tundora};
    --gt-bright-red: ${({ theme: { colors } }) => colors.brightRed};
    --gt-red-devil: ${({ theme: { colors } }) => colors.redDevil};
  }

  font-size: var(--font-size-5);
  line-height: var(--line-height-5);

  ${(props) => props.theme.extensions?.base?.global}
`;

export default GlobalStyles;
